import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Poll, PollService } from 'src/app/core/http/poll/poll.service';
import { SchemaService } from 'src/app/shared/services/schema/schema.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-polls',
  templateUrl: './adm-polls.component.html',
  styleUrls: ['./adm-polls.component.css']
})
export class AdmPollsComponent implements OnInit {
  polls: Poll[];
  PollForm: FormGroup;
  constructor(private _fb: FormBuilder, private pollService: PollService, private router: Router) { }
  ngOnInit(): void {
    this.getPolls();
    this.PollForm = this._fb.group({
      name: ['Новая форма'],
      private: [0],
      description: ['Описание']
    })
  }
  createPoll() {
    this.pollService.AddPoll(this.PollForm.value)
    .subscribe(resp=>{
      this.router.navigate(['mypolls/edit', resp.id])
    })
  }

  getPolls() {
    this.pollService.getPolls()
    .subscribe(resp=> {
      this.polls = resp;
    })
  }
  deletePoll(id, i) {
    this.pollService.DeletePoll(id)
    .subscribe();
    if (i !== -1) {
      this.polls.splice(i, 1);
    } 
  }




}
